import * as React from "react";
import "./Tabs.css";

export interface ITabsInfo {
    title: React.ReactNode;
    content: JSX.Element;
    disabled?: boolean;
}

export interface ITabsProps {
    id?: string;
    tabs: { [x: string]: ITabsInfo };
    currentTab: string;
    setCurrentTab: (x: string) => void;
}

export const CustomTabContainer = (props: ITabsProps) => {
    const keys = Object.keys(props.tabs);
    const tabs = props.tabs;

    return (
        <div className="nav-bar-container">
            <div className="nav-bar">
                {
                    keys.map((key) => {
                        const activeClassName = (key === props.currentTab) ? "active" : "";
                        return <div
                            key={props.id + key}
                            className={"item " + activeClassName}
                            onClick={() => { if (!tabs[key].disabled) { props.setCurrentTab(key) } }}
                        >
                            {tabs[key].title}
                        </div>
                    })
                }
            </div>
            <div>
                {
                    props.tabs[props.currentTab].content
                }
            </div>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/Tabs/Tabs.tsx